import { CommentModel } from "@/types";

// 翻訳データをパースするユーティリティ関数
export const parseTranslateData = (translateData: any): { translations: { [key: string]: string }, originalLanguage: string } | null => {
  try {
    if (!translateData) return null;
    
    // 文字列の場合はJSONパース
    const data = typeof translateData === 'string' ? JSON.parse(translateData) : translateData;
    
    if (!data || typeof data !== 'object') return null;
    
    const { originalLanguage, ...translations } = data;
    
    return {
      translations,
      originalLanguage: originalLanguage || 'ja'
    };
  } catch (error) {
    console.error('Failed to parse translate data:', error);
    return null;
  }
};

// 言語に応じたメッセージを取得
export const getMessageByLanguage = (comment: CommentModel, language: string): string => {
  if (comment.translations && comment.translations[language]) {
    return comment.translations[language];
  }
  // フォールバック: originalMessage -> message
  return comment.originalMessage || comment.message;
};

// コメントに翻訳データを適用
export const applyTranslationToComment = (comment: CommentModel, language: string): CommentModel => {
  return {
    ...comment,
    message: getMessageByLanguage(comment, language)
  };
};

// コメントに翻訳データを適用するヘルパー（getComment用）
export const applyTranslationToCommentHelper = (comment: any, translationData: { translations: { [key: string]: string }, originalLanguage: string }): Partial<CommentModel> => {
  return {
    translations: translationData.translations,
    originalLanguage: translationData.originalLanguage,
    originalMessage: comment.message || comment.body,
  };
};

